export const APP_NAME = 'overwheels-web';
